<template>
  <div class="text-block">
    <div class="name-title">
      {{ info.message }}
    </div>
    <div
      class="block-content"
      :class="isMobileDevice ? 'row no-margin' : 'block-flex'"
    >
      <div class="name-text" :class="isMobileDevice ? 'col-9' : ''">
        {{ displayVal }}
      </div>
      <div
        :id="editButtonId"
        class="edit-btn-container"
        :class="isMobileDevice ? 'col-2' : ''"
        @click="onClickEditQuestion"
      >
        <div class="progress-edit">
          <div class="progress-parent">
            <span class="progress-left">
              <span class="progress-bar border-primary" />
            </span>
            <span class="progress-right">
              <span class="progress-bar border-primary" />
            </span>
          </div>
          <div
            class="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center"
          >
            <div class="progress-text">
              {{ getUiText("app-nav-link-edit-1") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import Utils from "@/utils/utilities";
import _ from "underscore";
import store from "@/store";
import EventEmitter from "@/utils/eventEmitter";
import $ from "jquery";
@Component({})
export default class TextBlock extends Vue {
  public displayVal = "";
  public editButtonId = "";

  @Prop()
  public info!: any;

  @Prop()
  public isMobileDevice!: any;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }
  // languageSelected !: any;

  created() {}
  async mounted() {
    if (this.info && this.info.values && this.info.values.length > 0) {
      if (this.info.question_display_type === "text") {
        this.displayVal = this.info.values.join(", ");
      } else if (this.info.question_display_type === "single-list-2") {
        let currencyList = Object.keys(this.info.type_values);
        let selectedItem = " ";
        let selectedAmount: any = { from: "", id: "" };
        let amountList: any[] = [];
        let lowerRange: any;
        let upperRange: any;

        if (this.info && this.info.values && this.info.values.length > 0) {
          for (let i = 0; i < currencyList.length; i++) {
            let revenueList = this.info.type_values[currencyList[i]];
            if (revenueList.find((r: any) => r.id === this.info.values[0])) {
              selectedItem = currencyList[i];
              selectedAmount = revenueList.find(
                (r: any) => r.id === this.info.values[0],
              );
              amountList = revenueList;
            }
          }
          for (let i = 0; i < amountList.length; i++) {
            if (i != amountList.length - 1) {
              if (amountList[i].from % 1000000 !== 0) {
                lowerRange = (amountList[i].from / 1000000)
                  .toString()
                  .substring(
                    0,
                    ((amountList[i + 1].from - 1) / 1000000)
                      .toString()
                      .indexOf(".") + 2,
                  );
              } else {
                lowerRange = amountList[i].from / 1000000;
              }
              if ((amountList[i + 1].from - 1) / 1000000 !== 0) {
                upperRange = ((amountList[i + 1].from - 1) / 1000000)
                  .toString()
                  .substring(
                    0,
                    ((amountList[i + 1].from - 1) / 1000000)
                      .toString()
                      .indexOf(".") + 2,
                  );
              } else {
                upperRange = (amountList[i + 1].from - 1) / 1000000;
              }
              amountList[i].amountRange =
                lowerRange + "m" + " - " + upperRange + "m";
            } else {
              amountList[i].amountRange =
                ">= " + amountList[i].from / 1000000 + "m";
            }
          }

          this.displayVal = selectedItem + " " + selectedAmount.amountRange;
        }
      } else {
        if (
          this.info.type_values &&
          this.info.type_values != null &&
          this.info.type_values != undefined
        ) {
          let listKeyInJSON = await Utils.getQuestionsMatchedListKey(
            this.info.id,
          );
          if (
            this.info.type_values[listKeyInJSON] &&
            this.info.type_values[listKeyInJSON].length > 0
          ) {
            const valsSplit = this.info.values;
            let valsList: any[] = [];
            for (let p of valsSplit) {
              const keyVal: any = _.findWhere(
                this.info.type_values[listKeyInJSON],
                { id: p },
              );

              // 'if' is Special case for 'single-bubble' with id 'staff_count'.
              if (
                this.info.question_display_type === "single-bubble" &&
                this.info.id === "staff_count"
              ) {
                if (keyVal && keyVal.from >= 0) {
                  let allVals: any = "";
                  const itemRecIndex = this.info.type_values[
                    listKeyInJSON
                  ].findIndex((r: any) => r.id == p);
                  if (itemRecIndex >= 0) {
                    if (
                      itemRecIndex ===
                      this.info.type_values[listKeyInJSON].length - 1
                    ) {
                      allVals = ">= " + keyVal.from;
                    } else if (
                      this.info.type_values[listKeyInJSON][itemRecIndex + 1] &&
                      this.info.type_values[listKeyInJSON][itemRecIndex + 1]
                        .from
                    ) {
                      allVals =
                        "" +
                        keyVal.from +
                        " - " +
                        (parseInt(
                          this.info.type_values[listKeyInJSON][itemRecIndex + 1]
                            .from,
                        ) -
                          1);
                    } else {
                      allVals = "" + keyVal.from;
                    }
                  }
                  valsList.push(allVals);
                }
              } else {
                if (keyVal && keyVal.name) {
                  valsList.push(keyVal.name);
                }
              }
            }

            if (valsList && valsList.length > 0) {
              this.displayVal = valsList.join(", ");
            }
          }
        } else {
          this.displayVal = "";
          this.editButtonId = "";
        }
      }
    } else {
      this.displayVal = "";
      this.editButtonId = "";
    }
    await this.setEditDesign();
    await this.setEditButtonId();
  }
  setEditButtonId() {
    const dynId = "editButton" + Math.floor(Math.random() * 100);
    this.editButtonId = dynId;

    setTimeout(() => {
      const editbtn: any = document.getElementById(dynId);
      if (editbtn) {
        editbtn.addEventListener("mouseenter", this.onHoverEdit);
        editbtn.addEventListener("mouseleave", this.setEditDesign);
      }
    }, 100);
  }
  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }
  onClickEditQuestion() {
    EventEmitter.emit("APP_PROSPECT_QUESTION_EDIT", this.info);
  }

  setEditDesign() {
    $(".progress-edit").each(function () {
      const progressValue = 97;
      const perVal1 = (progressValue / 100) * 360;
      const perVal2 = ((progressValue - 50) / 100) * 360;
      const left = $(this).find(".progress-left .progress-bar");
      const right = $(this).find(".progress-right .progress-bar");
      if (progressValue > 0) {
        if (progressValue <= 50) {
          right.css("transform", "rotate(" + perVal1 + "deg)");
        } else {
          right.css("transform", "rotate(180deg)");
          left.css("transform", "rotate(" + perVal2 + "deg)");
        }
      }
    });
  }
  onHoverEdit() {
    $(".progress-edit").each(function () {
      const left = $(this).find(".progress-left .progress-bar");
      const right = $(this).find(".progress-right .progress-bar");
      left.css("transform", "rotate(1deg)");
      right.css("transform", "rotate(1deg)");

      for (let progressValue = 10; progressValue <= 100; ) {
        const perVal1 = (progressValue / 100) * 360;
        const perVal2 = ((progressValue - 50) / 100) * 360;
        if (progressValue > 0) {
          if (progressValue <= 50) {
            right.css("transform", "rotate(" + perVal1 + "deg)");
          } else {
            right.css("transform", "rotate(180deg)");
            left.css("transform", "rotate(" + perVal2 + "deg)");
          }
        }
        if (progressValue >= 90) {
          progressValue = progressValue + 7;
        } else {
          progressValue = progressValue + 10;
        }
      }
    });
  }
  beforeUnmount() {
    this.displayVal = "";
    this.editButtonId = "";
  }
}
</script>

<style lang="scss" scoped>
.block-content {
  .progress-edit {
    width: 51px !important;
    height: 51px !important;
    background: none;
    position: relative;
  }
  .progress-parent {
    width: 51px !important;
    height: 51px !important;
    background: none;
    position: absolute;

    transform: rotate(-85deg) !important;

    -webkit-transition: -webkit-transform 0.8s ease-in-out;
    -ms-transition: -ms-transform 0.8s ease-in-out;
    transition: transform 0.8s ease-in-out;
  }
  .progress-text {
    font-size: 13px;
    font-weight: 500;
    line-height: 19px;
    color: #b7b7b7;
  }
  .progress-edit::after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .progress-parent > span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  .progress-parent .progress-left {
    left: 0;
  }

  .progress-parent .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: 4px;
    border-style: solid;
    position: absolute;
    top: 0;
    opacity: 0.2;
  }

  .progress-parent .progress-left .progress-bar {
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
  }

  .progress-parent .progress-right {
    right: 0;
  }

  .progress-parent .progress-right .progress-bar {
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
  }

  .progress-parent .progress-value {
    position: absolute;
    top: 0;
    left: 0;
    background: white;
  }
  .border-primary {
    border-color: #b7b7b7 !important;
  }

  .edit-btn-container:hover {
    .progress-text {
      color: #387dff;
    }
    .progress-parent {
      transform: rotate(95deg) !important;

      .progress-bar {
        opacity: unset;
      }
    }
    .border-primary {
      border-color: #387dff !important;
    }
  }
}
</style>
